import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next/';

import styles from './Author.module.scss';
import Props from './Author.props';
import { Link } from '@components/containers';

const Author = ({ author, image, url }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.Author}>
      <div className={styles.Image}>
        <Image src={image} alt="" quality={60} layout="fill" />
      </div>
      <Link className={styles.Content} href={url}>
        <p className={styles.Title}>{t('GENERIC.AUTHOR')}:</p>
        <p className={styles.Name}>{author}</p>
      </Link>
    </div>
  );
};

export default Author;
